/** Интервалы скорости первого ответа для аналитики: [от, до) в секундах, до = null — без верхней границы. */
export const RESPONSE_BUCKETS = [
  { key: 'lt1', label: 'до 1 мин', fromSec: 0, toSec: 60 },
  { key: '1-2', label: '1–2 мин', fromSec: 60, toSec: 120 },
  { key: '2-5', label: '2–5 мин', fromSec: 120, toSec: 300 },
  { key: '5-10', label: '5–10 мин', fromSec: 300, toSec: 600 },
  { key: '10-20', label: '10–20 мин', fromSec: 600, toSec: 1200 },
  { key: '20-30', label: '20–30 мин', fromSec: 1200, toSec: 1800 },
  { key: 'gt30', label: 'больше 30 мин', fromSec: 1800, toSec: null },
] as const;

export type ResponseBucketKey = (typeof RESPONSE_BUCKETS)[number]['key'];
export const RESPONSE_BUCKET_KEYS = RESPONSE_BUCKETS.map((b) => b.key) as [ResponseBucketKey, ...ResponseBucketKey[]];

export function responseBucketOf(sec: number | null | undefined): ResponseBucketKey | null {
  if (sec == null) return null;
  return RESPONSE_BUCKETS.find((b) => sec >= b.fromSec && (b.toSec == null || sec < b.toSec))?.key ?? null;
}
